import { render, staticRenderFns } from "./PaymentCredentials.vue?vue&type=template&id=4f0a356c&"
import script from "./PaymentCredentials.vue?vue&type=script&lang=js&"
export * from "./PaymentCredentials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports